var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFullscreenClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.667 21.333h4v4h2.667v-6.666H6.667v2.666Zm4-10.666h-4v2.666h6.667V6.667h-2.667v4Zm8 14.666h2.667v-4h4v-2.666h-6.667v6.666Zm2.667-14.666v-4h-2.667v6.666h6.667v-2.666h-4Z"
})));
export default SvgFullscreenClose;